import { ref, computed, inject } from 'vue'

const giftcards = ref([])

export function useDiscounts() {
    const cart = inject('cart')

    const discountId = inject('discount', ref(null))
    const availableDiscounts = inject('discounts', ref([]))

    const discounts = computed(() => {
        return [
            ...giftcards.value,
            ...availableDiscounts.value.filter(discount => {
                return cart.value.find(item => discount.products.includes(item.id) && item.quantity > 0)
            })
        ]
    })

    const selectedDiscount = computed({
        get() {
            return discounts.value.find(discount => discount.id === discountId.value)
        },

        set(value) {
            discountId.value = value?.id ?? null
        }
    })

    return {
        allDiscounts: availableDiscounts,
        discounts,
        selectedDiscount,
        giftcards,
        discount: discountId,
        remove: () => {
            selectedDiscount.value = null
        }
    }
}